import styled from 'styled-components';

export const ForgotPasswordContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  > div {
    max-width: 500px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  form {
    width: 100%;
  }

  > svg {
    margin-bottom: 32px;
  }

  button {
    display: flex;
    width: 100%;
  }
`;

export const HeaderContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 16px;
`;

export const Title = styled.h1`
  color: var(--color-black-primary);
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  margin-bottom: 12px;
  width: 100%;
  text-align: center;
  margin-bottom: 8px;
`;

export const Description = styled.p`
  color: var(--color-gray-100);
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin-bottom: 0;
  width: 100%;
  max-width: 360px;
`;

export const ErrorMessage = styled.p`
  color: var(--color-red-100);
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 12px;
`;

export const SuccessMessage = styled.p`
  color: var(--color-white-primary);
  font-size: 17px;
  line-height: 24px;
  font-weight: 700;
  text-align: center;
  margin-bottom: 16px;
  width: 100%;
`;

export const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: calc(100% + 80px);
  margin: -40px -40px -40px;
  background: var(--color-black-primary);
  border-radius: 8px;
  overflow: hidden;
`;

export const SuccessContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 55px 96px 0;

  > svg {
    width: 100%;
    max-width: 289px;
    margin-bottom: 16px;
  }
`;

export const SuccessActions = styled.div`
  width: 100%;
  padding: 24px 48px;
  background: var(--color-black-primary);
`;

export const ActionButtons = styled.div`
  width: 100%;
  display: flex;
  margin-top: 24px;
`;

export const DocumentInputWrapper = styled.div`
  width: 100%;
  margin-left: 0 !important;
`;
